import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import TrainingDetail from "../../components/Clearith/TrainingDetail";

const SeviceSinglePage: React.FC = () => {
  useEffect(() => {
    document.title = "VTest Business English – 4 Skills | CLEARITH";
  }, []);

  return (
    <div className="clearith-site">
      <div className="body_wrap o-clip">
        <Header />
        <main>
          <TrainingDetail />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </div>
  );
};

export default SeviceSinglePage;
